import React from 'react';
import { FlexCol, BasicContainer, TextDynamic, FlexDynamic } from '@minecraft.atoms';
import { Carousel } from '@minecraft.molecules';
import Icon from '@minecraft.icon';
import { grid } from '@minecraft.themes';
import { useTranslation } from '@blocs.i18n';

export const TRUSTED_BRANDS_ICONS = [
  'brand-hulu',
  'brand-netflix',
  'brand-prime',
  'brand-max',
  'brand-visa',
  'brand-nike',
  'brand-verizon',
  'brand-amazon',
  'brand-toyota',
];

export const InfiniteBrandSroller = React.memo(() => {
  const { t } = useTranslation();
  const { md } = grid.breakpoints;
  return (
    <FlexDynamic w="full" justifyContent="center" alignItems="center" gap="3" mdProps={{ gap: '8' }}>
      <TextDynamic
        align="left"
        fontWeight="semibold"
        color="disabled"
        mdProps={{ align: 'center' }}
        as="h3"
        fontSize="bodyLarge"
      >
        {t('common:paywall.checkout.trustedBrands')}
      </TextDynamic>
      <BasicContainer w="full">
        <Carousel
          maxW="full"
          settings={{
            dots: false,
            infinite: true,
            speed: 5000,
            slidesToShow: 9,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            pauseOnHover: false,
            pauseOnFocus: false,
            arrows: false,
            responsive: [
              {
                breakpoint: parseInt(String(md), 10),
                settings: {
                  slidesToShow: 4,
                },
              },
            ],
          }}
        >
          {TRUSTED_BRANDS_ICONS.map((brand) => (
            <FlexCol key={brand} w="full" justifyContent="center" alignItems="center">
              <Icon name={brand} />
            </FlexCol>
          ))}
        </Carousel>
      </BasicContainer>
    </FlexDynamic>
  );
});
